import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens';

@Injectable({ providedIn: 'root' })
export class GtmService {
  private readonly document = inject(DOCUMENT);
  private readonly envConfig = inject(ENV_CONFIG);
  private initialized = false;

  init(): void {
    const gtm = this.envConfig.gtm;
    if (this.initialized || !gtm?.enabled || !gtm.key) {
      return;
    }

    const window = this.document.defaultView as (Window & { dataLayer?: Record<string, unknown>[] }) | null;
    if (!window) {
      return;
    }
    this.initialized = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const script = this.document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtm.key}`;
    this.document.head.appendChild(script);
  }
}
